import React from 'react';
import styled from 'styled-components';

interface MenuSectionProps {
  title?: string;
  children: React.ReactNode;
}

export const MenuSection = ({ title, children }: MenuSectionProps) => {
  return (
    <Group>
      {title && <GroupTitle>{title}</GroupTitle>}
      <ButtonContainer>{children}</ButtonContainer>
    </Group>
  );
};

const Group = styled.div`
  display: flex;
  padding: 0px var(--radius-large, 16px) 32px var(--radius-large, 16px);
  flex-direction: column;
  gap: var(--radius-large, 16px);
`;

const GroupTitle = styled.h2`
  color: var(--Light-Scheme-Monochrome-black, #232429);

  /* System/X-Large/xl-bold */
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 15.3px */
`;

const ButtonContainer = styled.div`
  display: flex;
  padding: var(--radius-medium, 8px) 24px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);
`;
